export default __webpack_public_path__ + "static/media/CarImages.SorentoMedium2.652170ed.jpg";